export default {
  path: '/ratio-new',
  meta: {
    title: '云仓配额',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/ratio-new`),
}



// WEBPACK FOOTER //
// ./src/views/RatioNew/router.js